export const calculateBirTax = (amount, rate) => {
    // Ensure inputs are numbers
    let taxBase = amount;
    if (typeof taxBase === 'string') {
        taxBase = parseFloat(taxBase.replace(/[^0-9.-]/g, '')) || 0;
    }
    
    const ratePct = parseFloat(rate) || 0;
    
    // Tax is based on VAT-exclusive amount (Gross / 1.12)
    const vatExclusiveBase = taxBase / 1.12;
    const tax = vatExclusiveBase * (ratePct / 100);
    
    return {
        vatExclusiveBase,
        tax
    };
};
